<t4-header icon="glyphicon-stats"></t4-header>

<t4-container>
  <ng-container toolbar>
    <button mat-button (click)="openDialog()"><mat-icon>add</mat-icon>Register tire change</button>
  </ng-container>
  <t4-data-table #tbl headline="" matSort [rawData]="data" [filterFields]="['RentalObject.Alias', 'RentalObject.Title', 'Location.Name' ,'CreatedBy']" [autoGenerateColumns]="false">

    <ng-container matColumnDef="DeleteAction">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:75px;"></mat-header-cell>

      <mat-cell *matCellDef="let row" style="max-width:75px;">
        <mat-icon (click)="!row.Invoiced && delete(row)"
                  [ngClass]="{'disabled-icon': row.Invoiced}"
                  style="cursor: pointer;">
          delete
        </mat-icon>
      </mat-cell>

      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="RentalObject">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:200px;">Trailer</mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width:200px;"><t4-object-link [objectId]="row.RentalObjectId">{{row.RentalObject.Alias}} - {{ row.RentalObject.Title }}</t4-object-link></mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Location">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:250px;">Location</mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width:250px;"><t4-location-link [locationId]="row.LocationId">{{ row.Location.Name }}</t4-location-link></mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Amount">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:100px;">Amount</mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width:100px;"> {{ row.Amount}}  </mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Invoiced">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:100px;">Invoiced</mat-header-cell>
      <mat-cell *matCellDef="let row" style=" max-width:100px;">
        @if(row.Invoiced == true)
        {<mat-icon style="color:green;">checked</mat-icon>}
        @else
        {<mat-icon style="color:red;">close</mat-icon>}
      </mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="InvoicedAt">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:200px;">Invoiced At</mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width:200px;">{{row.InvoicedAt}}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="CreatedAt">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:250px;">Created at</mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width:250px;">{{ row.CreatedAt | date : 'd MMM y, HH:mm' }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="CreatedBy">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Created By</mat-header-cell>
      <mat-cell *matCellDef="let row">{{row.CreatedBy}}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
  </t4-data-table>
</t4-container>
